module.exports = __webpack_public_path__ + "img/message-notice.cbadcdc9.png";